module.exports = __webpack_public_path__ + "img/medicine.6dc9bac9.svg";